export const PREFETCH_HOVER_DELAY_MS = 75;

/** Default prefetch cache window for nav targets: stale after 30s, evicted after 5m. */
export const NAV_PREFETCH_CACHE_FOR: [string, string] = ["30s", "5m"];

export const NO_PREFETCH_ROUTES: readonly RegExp[] = [/^mailto:/i, /^tel:/i, /^https?:\/\//i, /\/_msearch(\?|$)/];

export function isPrefetchableHref(href: string | undefined): href is string {
  if (!href) return false;
  return !NO_PREFETCH_ROUTES.some((re) => re.test(href));
}
